import { useEffect, useState } from 'react';
import Modal from '../../UI/Modal/Modal';
import '../Administracija.css';
import { toast } from 'react-hot-toast';
import OpcijeProgramaGridProvider from './OpcijeProgramaGridProvider';
import OInput from '../../UI/FormControls/OInput';
import CheckBox from '../../UI/FormControls/CheckBox';

const initialConfig = {
  url: 'vracanje_opcija_programa',
};

function OpcijePrograma(props) {
  const [formData, setFormData] = useState({
    naziv: '',
    ikonica: '',
    cvor: false,
    podcvor: false,
    dokument: false,
  });
  const [status, setStatus] = useState(1);
  const [openDelete, setOpenDelete] = useState(false);

  useEffect(() => {
    props.sendRequest(initialConfig);
    props.handleRefreshData(initialConfig);
  }, []);

  const groupData = (form = formData) => {
    const config = {
      url:
        status === 1
          ? 'unos_opcija_objekat'
          : status === 2
          ? 'izmena_opcija_objekat'
          : '',
      status,
      method: 'POST',
      data: {
        id: form ? form.id : 0,
        naziv: form ? form.naziv : '',
        ikonica: form ? form.ikonica : '',
        cvor: form ? form.cvor : false,
        podcvor: form ? form.podcvor : false,
        dokument: form ? form.dokument : false,
        vremeProm: new Date(),
        idKorProm: +localStorage.getItem('idKorisnika'),
      },
    };
    props.sendRequest(config);
  };

  useEffect(() => {
    if (props.save === true) {
      groupData();
    }
    props.handleSave(false);
  }, [props.save]);

  useEffect(() => {
    const newFormData = {
      ...formData,
      id: 0,
      naziv: '',
      ikonica: '',
      cvor: false,
      podcvor: false,
      dokument: false,
    };
    setFormData(newFormData);
    setStatus(1);
  }, [props.data]);

  const handleOpenDelete = (id) => {
    setOpenDelete(true);
    const newFormData = {
      ...formData,
      id,
    };
    setFormData(newFormData);
  };

  // funkcija za brisanje opcije
  const handleObrisi = () => {
    const config = {
      url: 'brisanje_opcija_programa',
      status: 3,
      method: 'POST',
      data: {
        id: formData.id,
        vremeProm: new Date(),
        idKorProm: +localStorage.getItem('idKorisnika'),
      },
    };
    props.sendRequest(config);
    setOpenDelete(false);
    const newFormData = {
      ...formData,
      id: 0,
    };
    setFormData(newFormData);
  };

  // klik na red setuje podatke za izmenu
  const handleRowClick = (event) => {
    const newFormData = {
      ...formData,
      id: event.row.id,
      naziv: event.row.naziv,
      ikonica: event.row.ikonica || '', // ako nema ikonica onda je prazan string
      cvor: event.row.cvor,
      podcvor: event.row.podcvor,
      dokument: event.row.dokument,
      vremeProm: new Date(),
      idKorProm: +localStorage.getItem('idKorisnika'),
    };
    setStatus(2);
    setFormData(newFormData);
  };

  const handleChange = (event) => {
    let newFormData = {};
    if (typeof formData[event.target.name] === 'boolean') {
      newFormData = {
        ...formData,
        [event.target.name]: event.target.checked,
      };
    } else {
      newFormData = {
        ...formData,
        [event.target.name]: event.target.value,
      };
    }
    setFormData(newFormData);
  };

  // eslint-disable-next-line no-unused-expressions
  props.isSuccess && toast.success('Opcija programa uspešno uneta');

  return (
    <>
      {openDelete && (
        <Modal
          title="Upozorenje!"
          message="Da li ste sigurni da želite da obrišete izabranu stavku?"
          type="warning"
          onClose={() => setOpenDelete(false)}
          onConfirm={handleObrisi}
        />
      )}
      {props.error && (
        <Modal
          title="Greška!"
          message={props.error}
          type="error"
          onClose={props.clearError}
        />
      )}
      <div style={{ display: 'inline-flex', width: '100%' }}>
        <div>
          {/* <span className="label" htmlFor="naziv">
            Naziv opcije
          </span>
          <br />
          <input
            className="input_text"
            id="naziv"
            type="text"
            name="naziv"
            style={{ width: '300px' }}
            autoComplete="off"
            value={formData.naziv}
            onChange={handleChange}
          /> */}
          <OInput
            label="Naziv opcije"
            name="naziv"
            value={formData.naziv}
            id="naziv"
            type="text"
            style={{ width: '300px' }}
            handleChange={handleChange}
          />
        </div>
        <div>
          {/* <span className="label" htmlFor="ikonica">
            Ikonica
          </span>
          <br />
          <input
            className="input_text"
            id="ikonica"
            type="text"
            name="ikonica"
            style={{ width: '200px' }}
            autoComplete="off"
            value={formData.ikonica}
            onChange={handleChange}
          /> */}
          <OInput
            label="Ikonica"
            name="ikonica"
            value={formData.ikonica}
            id="ikonica"
            type="text"
            style={{ width: '200px' }}
            handleChange={handleChange}
          />
        </div>
        <div style={{ display: 'inherit', alignItems: 'end' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            {/* <input
              className="check"
              name="cvor"
              type="checkbox"
              id="cvor"
              onChange={handleChange}
              checked={formData.cvor}
            /> */}
            <CheckBox
              label="Čvor"
              name="cvor"
              checked={formData.cvor}
              handleChange={handleChange}
            />
            {/* <label
              className="label"
              htmlFor="cvor"
              style={{ cursor: 'pointer' }}
            >
              Čvor
            </label> */}
          </div>
          <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            {/* <input
              className="check"
              name="podcvor"
              type="checkbox"
              id="podcvor"
              onChange={handleChange}
              checked={formData.podcvor}
            />
            <label
              className="label"
              htmlFor="podcvor"
              style={{ cursor: 'pointer' }}
            >
              Podčvor
            </label> */}
            <CheckBox
              label="Podčvor"
              name="podcvor"
              checked={formData.podcvor}
              handleChange={handleChange}
            />
          </div>
          <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            {/* <input
              className="check"
              name="dokument"
              type="checkbox"
              id="dokument"
              onChange={handleChange}
              checked={formData.dokument}
            />
            <label
              className="label"
              htmlFor="dokument"
              style={{ cursor: 'pointer' }}
            >
              Dokument
            </label> */}
            <CheckBox
              label="Dokument"
              name="dokument"
              checked={formData.dokument}
              handleChange={handleChange}
            />
          </div>
        </div>
      </div>
      <OpcijeProgramaGridProvider
        data={props.data}
        loading={props.isLoading}
        handleRowClick={handleRowClick}
        handleOpenDelete={handleOpenDelete}
      />
    </>
  );
}

export default OpcijePrograma;
